import { render, staticRenderFns } from "./SetBookInfo.vue?vue&type=template&id=f0792b20"
import script from "./SetBookInfo.vue?vue&type=script&lang=ts"
export * from "./SetBookInfo.vue?vue&type=script&lang=ts"
import style0 from "./SetBookInfo.vue?vue&type=style&index=0&id=f0792b20&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports